import React from "react";
import Typography from "@material-ui/core/Typography";
import { Button } from "../../../node_modules/@material-ui/core";
import StepInstructions from "./StepInstructions";
import withRoot from '../../withRoot';

class Step1 extends React.Component {
  render() {
    const { mainClasses, handleNext } = this.props;

    return (
      <React.Fragment>
        <div>
          <Typography className={mainClasses.stepTitle} variant="title" component="h3">Terminaalien vaihto</Typography>
        </div>  
        <div> 
          <StepInstructions/>
          <div className={mainClasses.buttonWrapper}>
            <Button className={mainClasses.stepButton} variant="contained" color="primary" onClick={ () => handleNext(1) }>Lue QR-koodi</Button>
          </div>
          <div className={mainClasses.buttonWrapper}>
            <Button className={mainClasses.stepButton} variant="contained" color="secondary" onClick={ () => handleNext(2) }>Syötä ID-tunnus</Button>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withRoot(Step1);



// WEBPACK FOOTER //
// ./src/components/Steps/Step1.js